import React, { ReactNode } from 'react';
import { Text, TextProps, StyleProp, TextStyle } from 'react-native-web';
import { typography } from '../../utils/styling';

interface CustomTextProps extends Omit<TextProps, 'style'> {
  children: ReactNode;
  variant?: 'h1' | 'h2' | 'h3' | 'body' | 'small';
  color?: string;
  align?: 'left' | 'center' | 'right';
  weight?: keyof typeof typography.fontWeight;
  style?: StyleProp<TextStyle>;
}

const CustomText: React.FC<CustomTextProps> = ({
  children,
  variant = 'body',
  color = '#000000',
  align = 'left',
  weight = 'normal',
  style,
  ...props
}) => {
  const getFontSize = () => {
    switch (variant) {
      case 'h1':
        return typography.fontSize.xxlarge;
      case 'h2':
        return typography.fontSize.xlarge;
      case 'h3':
        return typography.fontSize.large;
      case 'small':
        return typography.fontSize.small;
      default:
        return typography.fontSize.base;
    }
  };

  return (
    <Text
      style={[
        {
          fontFamily: typography.fontFamily.base,
          fontSize: getFontSize(),
          color,
          textAlign: align,
          fontWeight: typography.fontWeight[weight],
        },
        style,
      ]}
      {...props}
    >
      {children}
    </Text>
  );
};

export default CustomText; 